<template>
    <div class="bot-name-box"
         v-loading="loading"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.5)">

        <el-dialog
                :title="!lockPrice_ ? (!type ? '委托买入确认' : '委托卖出确认') : (!type ? '市价买入' : '市价卖出')"
                class="xianjia"
                :class="{'greenBtn': type === 1}"
                custom-class="dellDiaLogClass"
                :append-to-body="true"
                :center="true"
                :show-close="false"
                @close="handleClose(false)"
                :visible.sync="dialogVisible"
                width="30%">
            <!-- 限价交易 -->
            <div class="xianjiaTable">
                <span><b>账户</b> {{trade_account}}</span>
                <span><b>名称</b> {{nowDetail.name}}</span>
                <span><b>代码</b> {{nowDetail.code ? nowDetail.code.substr(2) : ''}}</span>
                <span><b>数量</b> <i> {{buyOrSellCount}}</i></span>
                <span><b>价格</b> <i> {{lockPrice_ ? '市价': dellPrice}}</i></span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose(false)">取 消</el-button>
                <el-button :class="{'greenBtn': type === 1}" :type="!lockPrice_ ? 'default' :'primary'"
                           @click="handleClose(true)">确 定</el-button>
            </span>
        </el-dialog>


        <div class="bot-name-th" :class="{'green': type}">
            {{type ? '卖出股票: ':'买入股票: '}}{{nowDetail.name}}
        </div>
        <div class="bot-form-box">
            <el-popover
                    placement="top"
                    width="160"
                    @after-enter="inputFocus"
                    v-model="visible">
                <el-autocomplete
                        class="inline-input"
                        v-model="willSearchKeyword"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入内容"
                        placement="top"
                        ref="fastSearch"
                        value-key="symbol"
                        popper-class="fastSeachList"
                        :popper-append-to-body="false"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                >
                    <template slot-scope="props">
                        <template v-if="props.item.code !== 500">
                            <span class="search symbol">{{ props.item.symbol }}</span>
                            <span class="search name">{{ props.item.name }}</span>
                        </template>
                        <template v-else>
                            <span class="search name">{{ props.item.msg }}</span>
                        </template>
                    </template>
                </el-autocomplete>
                <div slot="reference">
                    <div class="bot-form-lt">股票代码:</div>
                    <input type="text" readonly="true" v-model="nowDetail.symbol"
                           class="bot-form-int" placeholder="股票代码"/>
                </div>
            </el-popover>
        </div>
        <div class="bot-form-box">
            <div class="bot-form-lt">委托价格:</div>
            <div class="bot-form-int wid">
                <input id="mpbox" :readonly="lockPrice_" v-model="dellPrice"
                       type="number" class="bot-form-int2"
                       placeholder="委托价格"/>
                <div class="bot-form-price" :class="{'gai': lockPrice_}" @click="lockPrice" id="mprice">
                    <div class="img"></div>
                    市价
                </div>
                <div class="bot-up-down">
                    <div class="bot-up price-add" @click="setNowDellPrice(0.01)"></div>
                    <div class="bot-down price-elss" @click="setNowDellPrice(-0.01)"></div>
                </div>
            </div>
        </div>
        <div class="bot-form-box">
            <div class="bot-form-lt">可用资金:</div>
            <input type="number" readonly="true" v-model="can_money" class="bot-form-int" placeholder="可用资金"/>
        </div>
        <div class="bot-form-box">
            <div class="bot-form-lt">{{type ? '可卖数量': '可买数量'}}:</div>
            <input type="number" readonly="true" v-model="canBuyOrSellCount" class="bot-form-int"
                   :placeholder="type ? '可卖数量': '可买数量'"/>
        </div>
        <el-radio-group class="bot-select-box" v-model="radio2">
            <el-radio :label="1">全部</el-radio>
            <el-radio :label="2">1/2</el-radio>
            <el-radio :label="3">1/3</el-radio>
            <el-radio :label="4">1/4</el-radio>
        </el-radio-group>
        <div class="bot-form-box">
            <div class="bot-form-lt">{{type ? '卖出数量': '买入数量'}}:</div>
            <div class="bot-form-int wid">
                <input type="number" v-model="buyOrSellCount"
                       @focus="buyOrSellCountInput(true)"
                       @blur="buyOrSellCountInput(false)"
                       class="bot-form-int3" id="num"
                       :placeholder="'请输入' + (type ? '卖出数量': '买入数量')"/>
                <div class="bot-form-price padt">股</div>
                <div class="bot-up-down gai">
                    <div class="bot-up gu-add" @click="setBuyOrSellCount(100)"></div>
                    <div class="bot-down gu-elss" @click="setBuyOrSellCount(-100)"></div>
                </div>
            </div>
        </div>
        <div class="trade-btn-box">
            <div class="btn-box1" @click="setDealToDefault()">复位</div>
            <div class="btn-box2" @click="dellGpDiaLogInfo()" :disabled="btndisabled" :class="{'green': type}">
                <span></span>{{type
                ? '卖出':'买入'}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BaseFooterDeal",
        props: {
            type: {
                type: Number
            },
            price: {
                type: String
            }
        },
        data: function () {
            return {
                visible: false,
                radio2: 1, // 仓位
                lockPrice_: false,
                dellPrice_: null,
                canBuyOrSellCount: null,
                buyOrSellCount: 0,
                btndisabled: false,
                loading: false,
                dialogVisible: false,
                buyOrSellCountInputIng: false,
                isKCB: false,
                willSearchKeyword: null
            }
        },
        computed: {
            nowDetail: function () {
                return this.$store.state.now_chois_gp_item || {
                    symbol: "", sellOnePri: '', name: '', buyOnePri: ''
                }
            },
            can_money: function () {
                if (this.$store.state.account_info) {
                    return this.$store.state.account_info.can_money.replace(/,/g, '');
                }
                return 0;
            },
            account_info: function () {
                if (this.$store.state.account_info) {
                    return this.$store.state.account_info
                }
                return null;
            },
            dellPrice: {
                get: function () {
                    return !this.lockPrice_ ? this.dellPrice_ : this.nowDetail.latestPrice;
                },
                set: function (value) {
                    this.dellPrice_ = value;
                }
            },
            token: function () {
                return this.$store.state.now_token;
            },
            trade_account: function () {
                return this.$store.state.now_trade_account;
            }
        },
        watch: {
            account_info() {
                if (this.type === 1) {
                    this.getCanSellCount(this.nowDetail.code);
                }
            },
            type: function (ov) {
                this.dellPrice_ = 0;
                setTimeout(() => {
                    this.dellPrice_ = this.nowDetail.latestPrice;
                })
                this.radio2 = 1;
                if (ov === 1) {
                    this.getCanSellCount(this.nowDetail.code);
                }
            },
            can_money: function (v) {
                // 此处只对购买有效
                if (v && !this.type && this.dellPrice) {
                    if (this.isKCB) {
                        this.canBuyOrSellCount = Math.floor(+v / +this.dellPrice);
                        if (this.canBuyOrSellCount < 200) {
                            this.canBuyOrSellCount = 0;
                        }
                    } else {
                        this.canBuyOrSellCount = Math.floor((+v / +this.dellPrice) / 100) * 100;
                    }
                    // 可用资金变动，当交易数量超过可交易数量，重新设置
                    if (this.buyOrSellCount > this.canBuyOrSellCount || !this.buyOrSellCount) {
                        this.buyOrSellCount = this.canBuyOrSellCount;
                        this.setBuyOrSellCountRedio();
                    }
                }
            },
            dellPrice: function (v) {
                // 此处只对购买有效
                if (v && !this.type && this.can_money) {
                    if (this.isKCB) {
                        this.canBuyOrSellCount = Math.floor(+this.can_money / +v);
                        if (this.canBuyOrSellCount < 200) {
                            this.canBuyOrSellCount = 0;
                        }
                    } else {
                        this.canBuyOrSellCount = Math.floor((+this.can_money / +v) / 100) * 100;
                    }
                    // 交易数量超过可交易数量，或者是0，重新设置
                    if (this.buyOrSellCount > this.canBuyOrSellCount || !this.buyOrSellCount) {
                        this.buyOrSellCount = this.canBuyOrSellCount;
                        this.setBuyOrSellCountRedio();
                    }
                }
            },
            price: function (ov) {
                if (ov) {
                    // 点击买卖5档加个，解锁市价，并设置加个
                    this.lockPrice_ = false;
                    this.dellPrice_ = ov;
                }
            },
            nowDetail: function (ov, oldV) {
                console.log(ov);
                if (ov && ov.hasOwnProperty('code')) {
                    this.isKCB = ov.code.substr(2, 3) === '688';
                }
                if (ov && !this.dellPrice_ || ov.code !== oldV.code) {
                    this.radio2 = 1;
                    this.dellPrice_ = this.nowDetail.latestPrice;
                    if (this.type === 1) {
                        this.getCanSellCount(ov.code);
                    } else {
                        if (this.isKCB) {
                            this.canBuyOrSellCount = Math.floor(+this.can_money / +this.dellPrice);
                            if (this.canBuyOrSellCount < 200) {
                                this.canBuyOrSellCount = 0;
                            }
                        } else {
                            this.canBuyOrSellCount = Math.floor((+this.can_money / +this.dellPrice) / 100) * 100;
                        }
                        this.buyOrSellCount = this.canBuyOrSellCount;
                        this.setBuyOrSellCountRedio();
                    }
                }
            },
            radio2: function (v) {
                if (this.can_money && this.dellPrice) {
                    if (this.isKCB) {
                        this.buyOrSellCount = Math.floor(this.canBuyOrSellCount / v);
                        if (!this.type && this.buyOrSellCount < 200) {
                            this.buyOrSellCount = 0;
                        }
                    } else {
                        if(this.type) {
                            this.buyOrSellCount = Math.floor(this.canBuyOrSellCount / v);
                        } else {
                            this.buyOrSellCount = Math.floor(this.canBuyOrSellCount / v / 100) * 100;
                        }
                    }
                } else {
                    this.buyOrSellCount = 0;
                }
            },
            canBuyOrSellCount(v) {
                // 可交易数量变化，如果交易数量大于可交易数量，重置
                if(this.buyOrSellCount > v) {
                    this.buyOrSellCount = v;
                }
            },
            buyOrSellCountInputIng: function (v) {
                if (!v) {
                    if(this.type) {
                        this.buyOrSellCount = Math.max(0, Math.min(this.buyOrSellCount, this.canBuyOrSellCount));
                    } else {
                        if (this.isKCB) {
                            this.buyOrSellCount = this.canBuyOrSellCount > 200 ? Math.max(200, this.buyOrSellCount) : 0;
                        } else {
                            this.buyOrSellCount = Math.max(0, Math.floor(this.buyOrSellCount / 100) * 100);
                        }
                    }
                }
            }
        },
        mounted() {
            if (this.type === 1) {
                this.getCanSellCount(this.nowDetail.code);
            } else {
                if (this.isKCB) {
                    this.canBuyOrSellCount = Math.floor(+this.can_money / +this.dellPrice);
                    if (this.buyOrSellCount < 200) {
                        this.buyOrSellCount = 0;
                    }
                } else {
                    this.canBuyOrSellCount = Math.floor((+this.can_money / +this.dellPrice) / 100) * 100;
                }
                this.buyOrSellCount = this.canBuyOrSellCount;
                this.setBuyOrSellCountRedio();
            }
        },
        methods: {
            // 市值锁定
            lockPrice() {
                this.lockPrice_ = !this.lockPrice_;
                this.dellPrice_ = this.nowDetail.latestPrice;
            },
            // 关闭提示框的时候
            handleClose(done) {
                this.dialogVisible = false;
                if (done) {
                    this.dellGp();
                }
            },
            // 获取可买数量
            getCanSellCount(code) {
                this.$api.stockdetail(code, this.token, this.trade_account).then(res => {
                    if (res.data.code === 200) {
                        this.canBuyOrSellCount = res.data.data.num;
                        this.buyOrSellCount = this.buyOrSellCount === 0 ? this.canBuyOrSellCount : this.buyOrSellCount;
                        this.buyOrSellCount = Math.min(this.buyOrSellCount, this.canBuyOrSellCount);
                        console.log('股票监听', this.buyOrSellCount)
                        // this.setBuyOrSellCountRedio();
                    }
                })
            },
            // 复位
            setDealToDefault() {
                this.radio2 = 1;
                this.dellPrice = this.nowDetail.latestPrice;
            },
            // 打开提示框
            dellGpDiaLogInfo() {
                if (!this.canBuyOrSellCount) {
                    this.$message.error(!this.type ? '无法购买' : '没有可卖的');
                    return false;
                }
                if (+this.buyOrSellCount === 0 || +this.dellPrice === 0) {
                    this.$message.error('交易数量或价格非法');
                    return false;
                }
                // 打开提示框
                this.dialogVisible = true;
            },
            // 股票交易
            dellGp() {
                // 买入交易
                this.loading = true;
                if (!this.type) {
                    this.$api.createstrategy(this.token,
                        this.trade_account, this.nowDetail.code,
                        this.buyOrSellCount, this.dellPrice,
                        this.lockPrice_ ? 2 : 1).then(res => {
                        if (res.data.code === 200) {
                            this.$store.commit('UPDATE_ACCOUNT_INFO');
                            this.$store.commit('UPDATE_RIGHT_INFO');
                            this.$message({
                                message: res.data.data,
                                type: 'success'
                            });
                        } else {
                            this.$message.error(res.data.msg);
                        }
                        this.loading = false;
                        // 交易完成，设置交易为false
                    }).catch(() => this.loading = false)
                }
                // 卖出交易
                if (this.type === 1) {
                    this.$api.shellstrategy(this.token,
                        this.trade_account, this.nowDetail.code,
                        this.buyOrSellCount, +this.dellPrice,
                        this.lockPrice_ ? 2 : 1).then(res => {
                        if (res.data.code === 200) {
                            this.$store.commit('UPDATE_ACCOUNT_INFO');
                            this.$store.commit('UPDATE_RIGHT_INFO');
                            this.getCanSellCount(this.nowDetail.code);
                            this.$message({
                                message: res.data.data,
                                type: 'success'
                            });
                        } else {
                            this.$message.error(res.data.msg);
                        }
                        this.loading = false;
                        // 交易完成，设置交易为false
                    }).catch(() => this.loading = false)
                }
            },
            // 设置交易数量，100的倍数
            setBuyOrSellCount(num) {
                if(this.type) {
                    if (num > 0) {
                        this.buyOrSellCount = Math.min(this.canBuyOrSellCount, this.buyOrSellCount + 1)
                    } else {
                        this.buyOrSellCount = Math.max(0, this.buyOrSellCount - 1)
                    }
                } else {
                    if (this.isKCB) {
                        if (num > 0) {
                            this.buyOrSellCount = Math.min(this.canBuyOrSellCount, this.buyOrSellCount + 1);
                            if (this.buyOrSellCount < 200) {
                                this.buyOrSellCount = 200;
                            }
                        } else {
                            this.buyOrSellCount = Math.max(0, this.buyOrSellCount - 1);
                            if (this.buyOrSellCount < 200) {
                                this.buyOrSellCount = 0;
                            }
                        }
                    } else {
                        if (num > 0) {
                            this.buyOrSellCount = Math.min(this.canBuyOrSellCount, this.buyOrSellCount + num)
                        } else {
                            this.buyOrSellCount = Math.max(0, this.buyOrSellCount + num)
                        }
                    }
                }
            },
            // 设置交易的价格。不能超过涨停和跌停价
            setNowDellPrice(num) {
                if (num > 0) {
                    this.dellPrice = (+this.nowDetail.limitUpValue === -1 ? +this.dellPrice + num : Math.min(+this.nowDetail.limitUpValue, +this.dellPrice + num)).toFixed(2)
                } else {
                    this.dellPrice = Math.max(+this.nowDetail.limitDownValue, +this.dellPrice + num).toFixed(2)
                }
            },
            buyOrSellCountInput(inputIng) {
                this.buyOrSellCountInputIng = inputIng;
            },
            setBuyOrSellCountRedio() {
                if (this.radio2 !== 1) {
                    if (this.isKCB) {
                        this.buyOrSellCount = Math.floor(this.canBuyOrSellCount / this.radio2);
                        if(!this.type) {
                            if (this.buyOrSellCount < 200) {
                                this.buyOrSellCount = 0;
                            }
                        }
                    } else {
                        if(this.type) {
                            this.buyOrSellCount = Math.floor(this.canBuyOrSellCount / this.radio2);
                        } else {
                            this.buyOrSellCount = Math.floor(this.canBuyOrSellCount / this.radio2 / 100) * 100;
                        }
                    }
                }
            },
            querySearch(queryString, cb) {
                // 调用 callback 返回建议列表的数据
                if (queryString !== '') {
                    this.$api.searchGp(queryString, this.$store.state.now_token, this.$store.state.now_trade_account).then(res => {
                        console.log('快搜索', res);
                        if (res.data.code === 200) {
                            cb(res.data.data)
                        } else {
                            cb([])
                        }
                    })
                }
            },
            handleSelect(item) {
                this.$api.getGpDetail(item.symbol).then(res => {
                    console.log('更新当前个股行情到列表', res);
                    if (res.data.code === 1) {
                        this.$store.commit('UPDATE_GP_DETAIL', {data: res.data.data});
                        this.$store.commit('UPDATE_SOCKET_IDS', {code_s: [item.symbol], t: 'detail'});
                    }
                    this.$store.commit('SET_FOUCS_GP', item.symbol);
                    // 检查是否自选股
                    this.willSearchKeyword = '';
                    this.visible = false;
                });
            },
            inputFocus() {
                this.$refs.fastSearch.focus()
            }
        }
    }
</script>

<style lang="scss">
.fastSeachList {
    width: 185px!important;
    transform: translate(-12px, -10px);
    li {
        display: flex;
        span {
            flex: 1;
        }
        span:last-child {
            text-align: right;
        }
    }
}
</style>
